import { createQueryKeys } from '@lukemorales/query-key-factory';

export const authQueryKeys = createQueryKeys('auth', {
  csrf: null,
  info: null,
});
